/**
 * CPB Product Cards — Shared JavaScript
 * Variant change handler + AJAX Add to Cart
 * Used by: custom-product-block, main-collection, product-recommendations
 */
(function() {
  function initCpbCards(scope) {
    if (!scope) return;

    /* Variant change → update price + ATC id */
    scope.querySelectorAll('[data-cpb-variant]').forEach(function(sel) {
      sel.addEventListener('change', function() {
        var card = this.closest('.cpb-card');
        var opt = this.options[this.selectedIndex];
        var priceEl = card.querySelector('[data-cpb-price]');
        var btn = card.querySelector('[data-cpb-atc]');
        var currentPrice = opt.getAttribute('data-price');
        var comparePrice = opt.getAttribute('data-compare');

        if (priceEl) {
          var compareEl = priceEl.querySelector('[data-cpb-compare]');
          var currentEl = priceEl.querySelector('[data-cpb-current]');

          if (currentEl) {
            currentEl.textContent = currentPrice;
          } else {
            priceEl.textContent = currentPrice;
          }

          if (comparePrice && comparePrice.trim() !== '') {
            if (compareEl) {
              compareEl.textContent = comparePrice;
              compareEl.style.display = '';
            } else {
              var newCompare = document.createElement('span');
              newCompare.className = 'cpb-card__compare-price';
              newCompare.setAttribute('data-cpb-compare', '');
              newCompare.textContent = comparePrice;
              priceEl.insertBefore(newCompare, priceEl.firstChild);
            }
          } else if (compareEl) {
            compareEl.style.display = 'none';
          }
        }

        if (btn) btn.setAttribute('data-variant-id', this.value);
      });
    });

    /* AJAX Add to Cart */
    scope.querySelectorAll('[data-cpb-atc]').forEach(function(b) {
      b.addEventListener('click', function(e) {
        e.preventDefault();
        if (this.disabled || this.classList.contains('cpb--adding')) return;
        var vid = this.getAttribute('data-variant-id');
        if (!vid) return;
        var orig = this.textContent;
        this.textContent = 'ADDING…';
        this.classList.add('cpb--adding');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(vid), quantity: 1 })
        }).then(function(r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        }).then(function() {
          b.textContent = 'ADDED ✓';
          b.classList.remove('cpb--adding');
          setTimeout(function() { b.textContent = orig; }, 1800);
          if (typeof window.refreshCart === 'function') window.refreshCart();
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }).catch(function() {
          b.textContent = 'ERROR';
          b.classList.remove('cpb--adding');
          setTimeout(function() { b.textContent = orig; }, 1800);
        });
      });
    });

    /* Wishlist Click Handler */
    scope.querySelectorAll('.cpb-card__wishlist-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var imgUrl = this.getAttribute('data-product-image');
        
        /* Fill the heart to show it was clicked */
        this.setAttribute('fill', 'currentColor');
        
        /* Create popup container if missing */
        var popup = document.getElementById('cpb-wishlist-popup');
        if (!popup) {
          popup = document.createElement('div');
          popup.id = 'cpb-wishlist-popup';
          document.body.appendChild(popup);
        }
        
        /* Inject the popup HTML */
        popup.innerHTML = `
          <div class="cpb-wishlist-popup__inner">
            <button class="cpb-wishlist-popup__close" aria-label="Close popup" onclick="document.getElementById('cpb-wishlist-popup').classList.remove('cpb-show')">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.2">
                <path d="M1 1l12 12M13 1L1 13"/>
              </svg>
            </button>
            <div class="cpb-wishlist-popup__image-wrap">
              <img src="${imgUrl}" alt="Product Image" class="cpb-wishlist-popup__image">
            </div>
            <div class="cpb-wishlist-popup__text">
              Item has been temporarily added to wishlist, please login to save it permanently
            </div>
          </div>
        `;
        
        /* Force reflow to restart CSS animation */
        void popup.offsetWidth;
        popup.classList.add('cpb-show');
        
        /* Auto hide after 5 seconds */
        clearTimeout(window.cpbWishlistTimeout);
        window.cpbWishlistTimeout = setTimeout(function() {
          popup.classList.remove('cpb-show');
        }, 5000);
      });
    });
  }

  /* Initialize on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.cpb-grid, .cpb-horizontal-scroll').forEach(initCpbCards);
    });
  } else {
    document.querySelectorAll('.cpb-grid, .cpb-horizontal-scroll').forEach(initCpbCards);
  }

  /* Re-initialize when Shopify section is loaded/re-rendered (for recommendations AJAX) */
  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section) {
      section.querySelectorAll('.cpb-grid, .cpb-horizontal-scroll').forEach(initCpbCards);
    }
  });

  /* Also handle product recommendations which load via AJAX */
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && (node.classList.contains('cpb-grid') || node.classList.contains('cpb-horizontal-scroll') || node.classList.contains('cpb-card'))) {
            initCpbCards(node);
          }
          var grids = node.querySelectorAll ? node.querySelectorAll('.cpb-grid, .cpb-horizontal-scroll, .cpb-card') : [];
          grids.forEach(initCpbCards);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
